module.exports = __WEBPACK_EXTERNAL_MODULE_openfl_utils_ByteArray__;